export default __webpack_public_path__ + "static/media/fasqer.cc5fa6b5.png";